const defaultValues = {
  // camera_model: "",
  // camera_resolution: "",
  camera_details: [{ camera_model: "", camera_resolution: "" }],
  video_story_telling: "",
  sound_track: "",
  sound_track_notes: "",
  link_to_any_assets_used_previously: "",
  percentage_of_luts: "",
  lut_coloring: "",
  size_of_logo: "",
  position_of_logo_in_video: "",
  animation_of_logo: "",
  position_of_logo: "",
  prefered_font_name: "",
  prefered_font_size: "",
  prefered_font_character_spacing: "",
  export_setting_codec: "",
  export_setting_compression: "",
  export_setting_fps: "",
  resolution: "",
  reference_video_1: "",
  reference_video_2: "",
  reference_video_3: "",
  profile_addtitional_note: "",
  privacy_policy: "",
};

const TypesOfLuts = [
  { value: 1, label: 1 },
  { value: 2, label: 2 },
  { value: 3, label: 3 },
  { value: 4, label: 4 },
  { value: 5, label: 5 },
];

const whenOption = [
  { value: "opening", label: "Opening" },
  { value: "closing", label: "Closing" },
];

const animationOption = [
  { value: "zoom_in", label: "Zoom In" },
  { value: "zoom_out", label: "Zoom Out" },
];

const positionOption = [
  { value: "middle", label: "Middle" },
  { value: "top_right", label: "Top Right" },
  { value: "top_left", label: "Top Left" },
  { value: "bottom_right", label: "Bottom Right" },
  { value: "bottom_left", label: "Bottom Left" },
];

const codecOption = [
  { value: "h264", label: "H264" },
  { value: "h265", label: "H265" },
  { value: "apple_pro_res", label: "Apple ProRes" },
  { value: "quick_time", label: "Quick Time" },
];

const NELOption = [
  { value: "adobe_premiere", label: "ADOBE PREMIERE" },
  { value: "fcpx", label: "FCPX" },
  { value: "davinci_resolve", label: "DAVINCI RESOLVE" },
  { value: "other", label: "OTHER" },
];

const PopUpDropDown = [
  { value: 1, label: "Create New project pop up" },
  { value: 2, label: "Order Page T&C" },
  { value: 3, label: "Subscription Purchase T&C" },
];

const compressionOption = [
  { value: "max_depth", label: "MAX DEPTH" },
  { value: "vbr_10_mbps", label: "VBR 10MB/S" },
  { value: "vbr_25_mbps", label: "VBR 25MB/S" },
  { value: "vbr_50_mbps", label: "VBR 50MB/S" },
  { value: "cbr_10_mbps", label: "CBR 10MB/S" },
  { value: "cbr_25_mbps", label: "CBR 25MB/S" },
  { value: "cbr_50_mbps", label: "CBR 50MB/S" },
];

const framesOption = [
  { value: "fps_23", label: "23.976" },
  { value: "fps_24", label: "24" },
  { value: "fps_25", label: "25" },
  { value: "fps_29", label: "29.97" },
  { value: "fps_30", label: "30" },
];

const docFileType = "application/msword";

const docxFileType =
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

const pdfFileType = "application/pdf";

export {
  defaultValues,
  TypesOfLuts,
  whenOption,
  animationOption,
  positionOption,
  codecOption,
  NELOption,
  compressionOption,
  framesOption,
  docFileType,
  docxFileType,
  pdfFileType,
  PopUpDropDown,
};
